import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins, fontSize } from '../styles';
import { Container, Heading } from './ui';
import ContentCard from './ContentCard';

const StyledContentCards = styled.section`
  ${sectionMargins('30px', '70px')}
`;

const StyledHeader = styled.header`
  margin-bottom: 20px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-bottom: 30px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 40px;
  `}
`;

const StyledText = styled.p`
  margin-top: 12px;
  ${fontSize(18)};

  ${minBreakpointQuery.small`
    margin-top: 16px;
    ${fontSize(20)};
  `}
`;

const StyledItems = styled.div`
  display: grid;
  gap: 10px;

  ${minBreakpointQuery.small`
    gap: 20px;
  `}

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.mlarge`
    grid-template-columns: repeat(3, 1fr);
  `}

  ${minBreakpointQuery.large`
    row-gap: 30px;
  `}
`;

const ContentCards = ({ heading, text, items, alt }) => (
  <StyledContentCards>
    <Container>
      <StyledHeader>
        <Heading>{heading}</Heading>
        {text && <StyledText>{text}</StyledText>}
      </StyledHeader>
      <StyledItems>
        {items.map(({ heading, text, button }, i) => (
          <ContentCard
            key={`content-card-${i}`}
            heading={heading}
            text={text}
            button={button}
            alt={alt}
          />
        ))}
      </StyledItems>
    </Container>
  </StyledContentCards>
);

export default ContentCards;
